(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canila-promo-bar"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('canila-promo-bar'))customElements.define('canila-promo-bar',class extends HTMLElement{
connectedCallback(){
this.group=this.querySelector('[data-original]');this.track=this.querySelector('.canila-promo__track');this.viewport=this.querySelector('.canila-promo__viewport');this.button=this.querySelector('button');
if(!this.group||!this.group.children.length){this.hidden=true;this.style.display='none';return}
this.onToggle=()=>{const paused=this.classList.toggle('is-paused');this.button.setAttribute('aria-pressed',String(paused));this.button.setAttribute('aria-label',paused?'Kayan yazıyı oynat':'Kayan yazıyı duraklat')};
this.onSelect=event=>{if(this.contains(event.target)){this.classList.add('is-paused');this.button.setAttribute('aria-pressed','true');this.button.setAttribute('aria-label','Kayan yazıyı oynat')}};
this.button.addEventListener('click',this.onToggle);this.addEventListener('shopify:block:select',this.onSelect);
this.observer=new ResizeObserver(()=>this.schedule());this.observer.observe(this.viewport);this.observer.observe(this.group);
document.fonts.ready.then(()=>{if(this.isConnected)this.schedule()});this.schedule()
}
schedule(){cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.build())}
copy(node){const clone=node.cloneNode(true);clone.setAttribute('data-copy','');clone.setAttribute('aria-hidden','true');[clone,...clone.querySelectorAll('*')].forEach(el=>{el.removeAttribute('id');el.removeAttribute('data-shopify-editor-block')});clone.querySelectorAll('a,button,[tabindex]').forEach(el=>el.setAttribute('tabindex','-1'));return clone}
build(){const originals=[...this.group.children].filter(el=>!el.hasAttribute('data-copy'));const contentWidth=originals.reduce((sum,el)=>sum+el.getBoundingClientRect().width,0);const viewportWidth=this.viewport.clientWidth;if(!contentWidth||!viewportWidth)return;const signature=contentWidth+':'+viewportWidth;if(signature===this.signature)return;this.signature=signature;this.classList.remove('is-ready');this.track.querySelectorAll('[data-copy]').forEach(el=>el.remove());const repeats=Math.min(30,Math.max(1,Math.ceil(viewportWidth/contentWidth)));for(let i=1;i<repeats;i++)originals.forEach(el=>this.group.append(this.copy(el)));const clone=this.copy(this.group);clone.removeAttribute('data-original');this.track.append(clone);const speed=Number(this.dataset.speed)||45;this.style.setProperty('--promo-duration',this.group.getBoundingClientRect().width/speed+'s');this.button.hidden=true;this.classList.add('is-ready')}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.button?.removeEventListener('click',this.onToggle);this.removeEventListener('shopify:block:select',this.onSelect)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
